import { useState, useEffect } from 'react';
import { configApi } from '../services/api';
import type { FreeLimits } from '../types';

/** Valores padrão — usados enquanto a API não responde e como fallback em caso de erro */
const DEFAULT: FreeLimits = {
  maxPrivatePoolsCreated: 1,
  maxPrivatePoolMembers: 20,
  maxPrivatePoolsJoined: 2,
};

// Cache de módulo — busca uma única vez por sessão do browser
let cached: FreeLimits | null = null;
let promise: Promise<FreeLimits> | null = null;

/**
 * Hook que busca os limites do plano free do backend (endpoint público).
 * Usa cache de módulo para evitar múltiplas requisições entre componentes.
 * Retorna os valores padrão enquanto carrega e em caso de erro.
 */
export function usePublicFreeLimits() {
  const [limits, setLimits] = useState<FreeLimits>(cached ?? DEFAULT);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) {
      setLimits(cached);
      setLoading(false);
      return;
    }
    if (!promise) {
      promise = configApi
        .getPublicFreeLimits()
        .then((l) => {
          cached = l;
          return l;
        })
        .catch(() => DEFAULT);
    }
    promise.then((l) => {
      setLimits(l);
      setLoading(false);
    });
  }, []);

  return { limits, loading };
}
